var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailOpenLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 142,
    viewBox: "0 0 136 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_610_16389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2241 52.9431L68.0541 28.0513L99.8841 52.9431H36.2241Z",
    fill: "#293AB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2241 97.7751H99.884V52.9434H36.2241V97.7751Z",
    fill: "#293AB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2241 97.7751L68.0541 75.3583L36.2241 52.9434V97.7751",
    fill: "#29AAE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8856 97.7751L68.0557 75.3583L99.8856 52.9434V97.7751",
    fill: "#29AAE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0541 75.3583L60.2813 69.8846L36.2241 97.7751H99.8841L75.8269 69.8846L68.0541 75.3583Z",
    fill: "#1B92C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0541 75.3564L36.2241 52.9415L68.0541 69.4947L99.8841 52.9415L75.8269 69.8827L68.0541 75.3564",
    fill: "#202D8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8291 69.8821L99.8863 52.9408L75.8291 69.8821",
    fill: "#2E8AB0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_610_16389",
    x: 0.224121,
    y: 0.0512695,
    width: 135.662,
    height: 141.724,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.164706 0 0 0 0 0.670588 0 0 0 0 0.878431 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_610_16389"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_610_16389",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOpenLogo);
export default __webpack_public_path__ + "static/media/email-open-logo.4e504252be7127bbe60d47a0bec2081c.svg";
export { ForwardRef as ReactComponent };